import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Input from '@/components/Inputs/Input';
import useColor from '@/hooks/domain/useColor';

type FilterItemProps = {
  text: string;
  onBlur?: () => void;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  actionButton?: React.ReactNode;
  placeholder?: string;
  initFocus?: boolean;
};

const FilterItemEmail = ({
  readOnly,
  onChange,
  onBlur,
  text,
  actionButton,
  placeholder,
  initFocus,
}: FilterItemProps) => {
  const color = useColor();
  const inputStyle: CSSProperties = {
    width: '100%',
    minHeight: '44px',
    maxHeight: '144px',
    borderRadius: '6px',
    padding: '12px 14px',
    backgroundColor: color.gray200,
    fontSize: '12px',
  };

  if (readOnly) {
    inputStyle.border = 'unset';
    inputStyle.cursor = 'default';
  }

  return (
    <StyledFilterWrapper a="center" g={4}>
      <Input
        readOnly={readOnly}
        initFocus={initFocus}
        value={text}
        style={inputStyle}
        onChange={(e) => {
          onChange && onChange(e.target.value);
        }}
        onBlur={onBlur}
        placeholder={placeholder}
      />

      {actionButton}
    </StyledFilterWrapper>
  );
};

const StyledFilterWrapper = styled(Flex).attrs({
  a: 'center',
  g: 4,
  f: 1,
})`
  .delete-button {
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    .delete-button {
      opacity: 1;
    }
  }
`;

export default FilterItemEmail;
